import CourseType from './CourseType';

export default CourseType;
